import { useCallback, useMemo } from 'react'
import { Tooltip } from 'antd'
import { BBDTag, MaterialIcon } from '@gravitate-js/excalibrr'
import { useEbolMatchingContext } from './EbolMatchingContext'
import { useCanViewEbols } from './Hooks/useCanViewEbols'

export const EbolStatusTag = ({
  ebol_status,
  orderId,
  bolId,
  onClick,
}: { orderId?: string; bolId?: string; ebol_status?: 'matched' | 'unmatched'; onClick?: () => void }) => {
  const { viewBol } = useEbolMatchingContext()
  const canView = useCanViewEbols()
  const disabled = useMemo(() => !bolId && !onClick, [bolId, onClick])
  const handleClick = useCallback(() => {
    if (disabled) return
    viewBol({ orderId: orderId, bolId: bolId })
    onClick?.()
  }, [orderId, bolId, viewBol, onClick, disabled])

  const tooltipTitle = useMemo(() => {
    const matchText = ebol_status !== 'matched' ? 'not matched' : 'matched'
    const actionText = disabled ? '' : ' Click to review options'
    return `eBOL ${matchText}.${actionText}`
  }, [ebol_status, disabled])

  if (ebol_status === undefined || !canView) return
  return (
    <Tooltip title={tooltipTitle}>
      <BBDTag
        icon={<MaterialIcon icon='circle' fill />}
        textTransform='capitalize'
        success={ebol_status === 'matched'}
        warning={ebol_status !== 'matched'}
        style={{
          cursor: disabled ? undefined : 'pointer',
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
          textOverflow: 'clip',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
        onClick={handleClick}
      >
        <span style={{ color: 'var(--Grayscale-Gray-900)', fontWeight: 700 }}>{ebol_status}</span>
      </BBDTag>
    </Tooltip>
  )
}
